import { CatalogSearch } from './catalog-search';
import { getCountryMapList } from './catalogs/countries';
import { ServiceLocator } from '@app/engine/core/service-locator';
export var GroupType;
(function (GroupType) {
    GroupType[GroupType["ALL"] = 0] = "ALL";
    GroupType[GroupType["YEAR"] = 1] = "YEAR";
    GroupType[GroupType["YEAR_OR_LESS"] = 2] = "YEAR_OR_LESS";
    GroupType[GroupType["INTLDES"] = 3] = "INTLDES";
    GroupType[GroupType["NAME_REGEX"] = 4] = "NAME_REGEX";
    GroupType[GroupType["COUNTRY"] = 5] = "COUNTRY";
    GroupType[GroupType["COUNTRY_REGEX"] = 6] = "COUNTRY_REGEX";
    GroupType[GroupType["SHAPE_STRING"] = 7] = "SHAPE_STRING";
    GroupType[GroupType["BUS_STRING"] = 8] = "BUS_STRING";
    GroupType[GroupType["SCC_NUM"] = 9] = "SCC_NUM";
    GroupType[GroupType["ID_LIST"] = 10] = "ID_LIST";
    GroupType[GroupType["PAYLOAD_NAME_REGEX"] = 11] = "PAYLOAD_NAME_REGEX";
})(GroupType || (GroupType = {}));
export class ObjectGroup {
    ids = [];
    constructor(type, data = null) {
        const objData = ServiceLocator.getCatalogManager().objectCache;
        switch (type) {
            case GroupType.ALL:
                objData.every((sat) => {
                    if (sat.isSatellite()) {
                        this.ids.push(sat.id);
                    }
                    // Stop when we hit the max number of orbits to display
                    return this.ids.length <= Math.min(settingsManager.maxOribtsDisplayed, settingsManager.maxOribtsDisplayedDesktopAll);
                });
                break;
            case GroupType.YEAR:
                this.ids = CatalogSearch.year(ServiceLocator.getCatalogManager().getSats(), data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .filter((sat) => typeof sat.id !== 'undefined' && !sat.isStatic())
                    .map((sat) => sat.id);
                break;
            case GroupType.YEAR_OR_LESS:
                this.ids = CatalogSearch.yearOrLess(ServiceLocator.getCatalogManager().getSats(), data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .filter((sat) => typeof sat.id !== 'undefined' && !sat.isStatic())
                    .map((sat) => sat.id);
                break;
            case GroupType.INTLDES:
                this.ids = data
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((intlDes) => ServiceLocator.getCatalogManager().intlDes2id(intlDes))
                    .filter((id) => id !== null);
                break;
            case GroupType.NAME_REGEX:
                this.ids = CatalogSearch.objectName(objData, data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((obj) => obj.id);
                break;
            case GroupType.PAYLOAD_NAME_REGEX:
                this.ids = CatalogSearch.objectName(objData, data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((obj) => obj.id)
                    .filter((id) => objData[id].isPayload());
                break;
            case GroupType.COUNTRY:
                this.createGroupByCountry_(data, ServiceLocator.getCatalogManager().getSats());
                break;
            case GroupType.COUNTRY_REGEX:
                this.ids = CatalogSearch.country(ServiceLocator.getCatalogManager().getSats(), data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((obj) => obj.id);
                break;
            case GroupType.SHAPE_STRING:
                this.ids = CatalogSearch.shape(ServiceLocator.getCatalogManager().getSats(), data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((sat) => sat.id);
                break;
            case GroupType.BUS_STRING:
                this.ids = CatalogSearch.bus(ServiceLocator.getCatalogManager().getSats(), data)
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((sat) => sat.id);
                break;
            case GroupType.SCC_NUM:
                this.ids = data
                    // .slice(0, settingsManager.maxOribtsDisplayed)
                    .map((sccNum) => ServiceLocator.getCatalogManager().sccNum2Id(sccNum))
                    .filter((id) => id !== null);
                break;
            case GroupType.ID_LIST:
                this.ids = data.slice(0, settingsManager.maxOribtsDisplayed).map((id) => id);
                break;
            default:
                throw new Error('Unknown group type');
        }
    }
    hasObject = (id) => this.ids.findIndex((id_) => id_ === id) !== -1;
    // What calls the orbit buffer when selected a group from the menu.
    updateOrbits = () => {
        const orbitManagerInstance = ServiceLocator.getOrbitManager();
        this.ids.forEach((id) => {
            const obj = ServiceLocator.getCatalogManager().objectCache[id];
            if (obj.isMissile()) {
                orbitManagerInstance.updateOrbitBuffer(obj.id, obj);
            }
            else {
                orbitManagerInstance.updateOrbitBuffer(id);
            }
        });
        return this;
    };
    createGroupByCountry_(data, satData) {
        // Map country name to country code
        const expandedData = data.split('|').map((countryName) => getCountryMapList()[countryName]);
        // Concat data with expandedData using | as a delimiter
        data = `${data}|${expandedData.join('|')}`;
        this.ids = satData
            .filter((sat) => data.split('|').includes(sat.country) && !sat.sccNum5.startsWith('T'))
            // .slice(0, settingsManager.maxOribtsDisplayed)
            // eslint-disable-next-line arrow-body-style
            .map((sat) => {
            return sat.id;
        });
    }
}
